import LinkOut from "app/pages/sales-intelligence/common-components/table-cells/components/LinkOut/LinkOut";
import type { BaseCrmRecordData } from "app/pages/sales-intelligence/domain/crm-integration/types/records";

import { StyledCrmRecordCellWrapper, StyledLeadText } from "./styles";

type Props = {
    value: BaseCrmRecordData;
};

export const CrmRecordCell = ({ value }: Props) => (
    <StyledCrmRecordCellWrapper data-automation="crm-record-cell">
        <StyledLeadText
            overviewLink={value.link}
            tooltipContent={value.name}
            dataAutomation="crm-record-link"
        >
            {value.name}
        </StyledLeadText>

        <LinkOut
            href={value.link}
            tooltipContent={value.name}
        />
    </StyledCrmRecordCellWrapper>
);
